<template>
  <v-layout row wrap justify-center>
    <v-flex xs12>
      <h1 class="app-title font-red ">Davivienda Styleguide</h1>
    </v-flex>

    <!-- listas -->
    <v-flex xs12>
      <h3>Listas</h3>
    </v-flex>
    <v-flex xs4>
      <ui-list class="animated fadeInUp" :lista="lista"></ui-list>
    </v-flex>
    <v-flex xs4>
      <ui-list class="animated fadeInUp" :lista="lista" bullet="bullet-dav-ok"></ui-list>
    </v-flex>
    <v-flex xs4>
      <ui-list class="animated fadeInUp" :lista="lista" bullet="bullet-dav"></ui-list>
    </v-flex>

    <!-- Botones -->
    <!-- Estilos de botones, los contenidos editables son el aria, y el nombre del boton -->
    <!-- Para usar el @click directamente en componentes creados se usa @click.native -->
    <v-flex xs12>
      <h3>Botones</h3>
    </v-flex>
    <v-flex xs12 md6>
      <ui-button :content="'Primary button'" :botSize="250" :aria="'primary-button'" @click.native="dialogOne = true"></ui-button>
    </v-flex>
    <v-flex xs12 md6>
      <ui-button secondary :content="'Secondary button'" :botSize="350" :aria="'secondary-button'"></ui-button>
    </v-flex>
    <v-flex xs12 md4 text-xs-center>
      <ui-button-circle-secondary :aria="'Ejemplo de botón secundario'"></ui-button-circle-secondary>
    </v-flex>
    <v-flex xs12 md4>
      <ui-button-circle :partOne="'Certificados'" :partTwo="'de deposito a termino '" :partThree="'CDT'" :aria="'ejemplo de boton'"></ui-button-circle>
    </v-flex>
    <v-flex xs12 md4>
      <ui-button-circle :partOne="'Cuentas'" :partTwo="'Corrientes'" :aria="'otro ejemplo de boton'"></ui-button-circle>
    </v-flex>

    <v-flex xs12>
      <h3>Lista de botones</h3>
    </v-flex>

    <!-- Botones slide -->
    <v-flex xs12 sm6 md4 text-xs-center>
      <ui-botslidelist @currentBot="currentBotOne" :botsNames="bots"></ui-botslidelist>
    </v-flex>
    <v-flex xs12 sm6 md5 class="aligner" text-xs-center>
      <p :role="contenidoUno === (index+1)?'alert':''" class="animated fadeInRight" v-for="(texto, index) in bots" v-if="contenidoUno === (index+1)">
        {{texto.cont}}
      </p>
    </v-flex>

    <!-- botones top -->
    <v-flex xs12 mt-5>
      <ui-topnav @currentBot="currentBotTwo" :botsNames="botsDos"></ui-topnav>
    </v-flex>
    <v-flex xs12 class="aligner" text-xs-center>
      <p :role="contenidoDos === (index+1)?'alert':''" class="animated fadeInUp" v-for="(texto, index) in botsDos" v-if="contenidoDos === (index+1)">
        {{texto}}
      </p>
    </v-flex>

    <!-- Titulos -->

    <v-flex xs12>
      <h3>Titulos</h3>
    </v-flex>

    <v-flex xs12>
      <ui-title-red textTitle="Titulo derecha"></ui-title-red>
    </v-flex>

    <v-flex xs12>
      <ui-title-cen title="Titulo centrado"></ui-title-cen>
    </v-flex>

    <v-flex xs12>
      <br><br>
      <h1 class="app-title font-red ">Style red</h1>
    </v-flex>

    <!-- en titleLevel se pone el nivel del titulo (h1, h2, h3, etc) -->

    <v-flex xs12>
      <br><br>
      <ui-title-one titleAccess="Título de pantalla" titleLevel="h2">
        <template slot="partOne">Titulo<br></template>
        <template slot="partTwo">de</template>
        <template slot="partThree">pantalla</template>
      </ui-title-one>
    </v-flex>

    <v-flex xs12>
      <br><br>
      <ui-title-one titleAccess="Los Bancos reciben dinero de sus clientes a través de" titleLevel="h1">
        <template slot="partOne">Los Bancos reciben dinero<br></template>
        <!-- <template slot="partTwo"></template> -->
        <template slot="partThree">de sus clientes a través de</template>
      </ui-title-one>
    </v-flex>

    <v-flex xs12>
      <br><br>
      <ui-title-one titleAccess="¿Cuales son?" titleLevel="h1">
        <template slot="partOne">¿Cuales</template>
        <!-- <template slot="partTwo"></template> -->
        <template slot="partThree">son?</template>
      </ui-title-one>
    </v-flex>

    <v-flex xs12>
      <br><br>
      <ui-title-two titleAccess="¿Que son?" titleLevel="h2">
        <template slot="partOne">¿Que</template>
        <!-- <template slot="partTwo">Son?</template> -->
        <template slot="partThree">Son?</template>
      </ui-title-two>
    </v-flex>

    <!-- Videos -->
    <v-layout row wrap>
      <v-flex xs12>
        <br><br><br>
        <h3>Videos</h3>
      </v-flex>
      <!-- el tamaño del video se modifica con el valor que se ponga en videoSize 
      Siempre poner un nombre para el video con el prop vidTittle-->
      <v-flex xs12 md6 text-xs-center>
        <h4>Video youtube</h4>
        <!-- para video de youtube se usa el prop youtubeEmbed
        el embed se toma desde la página de youtube, dando clik en compartir,  luego en insertar, y del url que da, se toma 
        lo que sale despues del embed/, por ejemplo de https://www.youtube.com/embed/TSuXenPuOgQ se toma TSuXenPuOgQ -->
        <video-app vidTittle="Lenguaje de señas" :videoSize="500" youtubeEmbed="TSuXenPuOgQ"></video-app>
      </v-flex>
      <v-flex xs12 md6 text-xs-center>
        <h4>Video local</h4>
        <!-- Para video local se pone el nombre y la extensión del video, todos los videos deben estar en la carpeta assets/videos -->
        <video-app vidTittle="Animación" :videoSize="500" videoEmbed="bunny.mp4"></video-app>
      </v-flex>
    </v-layout>

    <!-- ventana con video en lenguaje de señas -->
    <v-flex xs12>
      <br><br><br>
      <h3>Ventana con video en lenguaje de señas</h3>
    </v-flex>
    <v-flex sm6 text-xs-center>
      <accesvideo-app vidTittle="Lenguaje de señas" :videoSize="700" youtubeEmbed="TSuXenPuOgQ"></accesvideo-app>
    </v-flex>
    <v-flex sm6 text-xs-center>
      <accesvideo-app vidTittle="Lenguaje de señas" :videoSize="700" videoEmbed="bunny.mp4"></accesvideo-app>
    </v-flex>

    <!-- Circulos numeros -->

    <v-flex xs12>
      <br><br><br>
      <h3>Num styles</h3>
    </v-flex>
    <v-flex xs4>
      <ui-circle-span :botProp="['1', 'circ-gran', 'back-red']" :aria="'Item número uno'"></ui-circle-span>
    </v-flex>
    <v-flex xs4>
      <ui-circle-span :botProp="['2', '', 'back-orange']" :aria="'Item número dos'"></ui-circle-span>
    </v-flex>
    <v-flex xs4>
      <ui-circle-span :botProp="['3', 'circ-peq', 'back-red']" :aria="'Item número tres'"></ui-circle-span>
    </v-flex>

    <!-- Actividades  -->

    <!-- pregustas con opciones de estilo circular -->
    <v-flex xs12 mt-5>
      <ui-act-preguntas01 :actividad="actividad"></ui-act-preguntas01>
    </v-flex>

    <!-- banner list -->
    <banner-slide-app :numeroBotones="4">
      <div class="animated fadeInRight" slot="cont0">
        Contenido 1
      </div>
      <div class="animated fadeInRight text-xs-center" slot="cont1">
        Contenido 2
      </div>
      <div class="animated fadeInRight" slot="cont2">
        Contenido 3
      </div>
      <div class="animated fadeInRight" slot="cont3">
        Contenido 4
      </div>
    </banner-slide-app>

    <!-- fin del curso -->
    <v-flex xs12>
      <h3>Fin del curso</h3>
    </v-flex>
    <ui-finalcurso class="animated rotateIn"></ui-finalcurso>

    <!-- Modals -->

    <v-dialog v-model="dialogOne" max-width="290">
      <v-card>
        <v-card-title class="headline">Titulo</v-card-title>
        <v-card-text>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas vestibulum felis condimentum fringilla tempor. Ut sagittis elementum diam, eget ultrices lacus. Nullam venenatis
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click.native="dialogOne = false">cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      contenidoUno: 0,
      contenidoDos: 0,
      dialogOne: false,
      lista: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut ",
        "non dolor dignissim, venenatis ",
        "sem ut, pharetra purus. Donec malesuada tortor vitae libero ",
        "luctus tristique. Aliquam molestie faucibus gravida. Aliquam "
      ],
      actividad: {
        introduccion:
          "Teniendo en cuenta los productos de captación que ofrecen los bancos, elija el producto más apropiado para cada caso.",
        preguntas: [
          {
            pregunta:
              "Juan está fabricando velas y ocupa mucho tiempo en ello. Debe pagar a proveedores de manera constante y necesita una forma sencilla para hacerlo.",
            respuesta: "opcion-3"
          },
          {
            pregunta:
              "Susana está ahorrando para comprar un carro, pero quiere esperar a que salga al mercado el modelo del siguiente año. Ya tiene un dinero y quiere que, mientras tanto, le genere intereses.",
            respuesta: "opcion-1"
          },
          {
            pregunta:
              "Rubén tiene un dinero y quiere ganar intereses, pero requiere que esté disponible para el momento en que lo necesite.",
            respuesta: "opcion-2"
          }
        ],
        buttons: [
          {
            name: ["Cuentas", " de ahorro", ""],
            arialab: "Cuentas de ahorro",
            opcion: "opcion-1"
          },
          {
            name: ["Cuentas", " corrientes", ""],
            arialab: "Cuentas corrientes",
            opcion: "opcion-2"
          },
          {
            name: ["Certificados", "de deposito a termino ", "CDT"],
            arialab: "Certificados de ahorro a términos CDT",
            opcion: "opcion-3"
          }
        ],
        despedida: ["Puede aprender ", "mucho más,", " continúe con el curso"]
      },
      bots: [
        {
          name: "Boton 1",
          cont: "Contenido 1"
        },
        {
          name: "Boton 2",
          cont: "Contenido 2"
        },
        {
          name: "Boton 3",
          cont: "Contenido 3"
        },
        {
          name: "Boton 4",
          cont: "Contenido 4"
        }
      ],
      botsDos: ["Contenido 1", "Contenido 2", "Contenido 3"]
    };
  },
  methods: {
    currentBotOne(event) {
      this.contenidoUno = event;
    },
    currentBotTwo(event) {
      this.contenidoDos = event;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/helpers/variables.scss";
</style>



// WEBPACK FOOTER //
// Styleguide.vue?50e1d2c2